import { render, staticRenderFns } from "./IntegrationTeaser.vue?vue&type=template&id=c6c2952a&scoped=true&"
import script from "./IntegrationTeaser.vue?vue&type=script&lang=js&"
export * from "./IntegrationTeaser.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationTeaser.vue?vue&type=style&index=0&id=c6c2952a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c2952a",
  null
  
)

export default component.exports